const getAllAsObject = state => state.sdg.styles.byKey;

export default {
	getAllAsObject,
};
